var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Checkbox as SemanticCheckbox } from 'semantic-ui-react';
import cn from 'classnames';
import Icon from '../Icon';
export const Checkbox = (_a) => {
    var { label, fitted, className, id } = _a, rest = __rest(_a, ["label", "fitted", "className", "id"]);
    const htmlFor = typeof id === 'undefined' ? id : String(id);
    const labelElement = (React.createElement("label", { htmlFor: htmlFor },
        React.createElement(Icon, { name: "check" }),
        label));
    return (React.createElement(SemanticCheckbox, Object.assign({ className: cn(className, {
            fitted: fitted !== null && fitted !== void 0 ? fitted : !label,
        }), label: labelElement, id: htmlFor }, rest)));
};
Checkbox.displayName = 'Checkbox';
export default Checkbox;
//# sourceMappingURL=Checkbox.js.map